import { render, staticRenderFns } from "./GiftGuideTile.vue?vue&type=template&id=484dd261"
import script from "./GiftGuideTile.vue?vue&type=script&setup=true&lang=ts"
export * from "./GiftGuideTile.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {CreatorShopTile: require('/opt/rewardStyle/src/github.com/rewardStyle/ltk-vue/src/components/creator-shop/CreatorShopTile.vue').default})
